import type { FC } from 'react';
import type { BrandHeadline, Brand } from '../../api/rest/types';
import { BrandListHeadline } from '../BrandListHeadline';
import { BrandListItem } from '../BrandListItem';

export type BrandListProps = {
  brands: Brand[];
  brandHeadlines: BrandHeadline[];
};

/**
 * List component for brands page
 * */
export const BrandList: FC<BrandListProps> = ({ brands = [], brandHeadlines = [] }) => (
  <>
    <BrandListHeadline items={brandHeadlines} />
    {brands &&
      brands.map((item) => (
        <BrandListItem key={item.title} title={item.title} items={item.items} />
      ))}
  </>
);
